<template>
    <div class="panel panel-default" data-testid="order-detail-staged">
        <div class="panel-heading">
            <h4>{{ label }}</h4>
        </div>
        <div class="panel-body od-stack">
            <template v-if="staged">
                <od-key-value-list :items="items" />
                <od-collapsible-details :pairs="techPairs" />
                <a
                    :href="staged.showUrl"
                    class="btn btn-sm btn-primary od-staged__cta"
                >
                    <i class="fa fa-external-link" aria-hidden="true"></i>
                    {{ staged.showLabel }}
                </a>
            </template>
        </div>
    </div>
</template>

<script>
import OdCollapsibleDetails from './OdCollapsibleDetails.vue';
import OdKeyValueList from './OdKeyValueList.vue';

export default {
    name: 'OrderStagedOrderCard',
    components: { OdCollapsibleDetails, OdKeyValueList },
    props: {
        order: { type: Object, required: true },
    },
    computed: {
        staged() {
            return this.order.stagedOrder || null;
        },
        label() {
            return (this.order.ui && this.order.ui.labels && this.order.ui.labels.staged)
                || 'Ordine staged (Dropship)';
        },
        items() {
            const s = this.staged;

            return [
                { label: 'Partner', value: s.partner ? s.partner.charAt(0).toUpperCase() + s.partner.slice(1) : '—', strong: true },
                { label: 'Mapping', status: s.mappingStatus || 'unknown' },
                { label: 'Ordine Shopify', value: s.shopifyOrderName || '—', mono: !!s.shopifyOrderName },
                { label: 'Ordine DLM', value: s.dlmOrderId != null ? String(s.dlmOrderId) : '—', mono: s.dlmOrderId != null },
            ];
        },
        techPairs() {
            const s = this.staged;

            return [
                ['Staged ID', s.stagedId],
                ['Correlation ID', s.correlationId],
            ].filter(([, value]) => value != null && value !== '').map(([key, value]) => [key, String(value)]);
        },
    },
};
</script>
